import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-approval-confirm-dialog',
    template: `
    <h2 mat-dialog-title>Approve Facility</h2>
    <mat-dialog-content>
      <p>Do you want to approve this facility?</p>
      <div class="facility-info">
        <strong>Name: {{ data.facilityName }}</strong><br>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="onConfirm()">Confirm</button>
    </mat-dialog-actions>
  `,
    styles: [`
    .facility-info {
      padding: 16px;
      background-color: #f5f5f5;
      border-radius: 4px;
      margin-top: 16px;
    }
  `],
    standalone: false
})
export class ApprovalConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ApprovalConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { facilityName: string; facilityId: string }
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close('confirm');
  }
}